import { UserContextValue } from "contexts/new/UserContext";
import { trackEvent } from "services/frontend/Segment";

export function useRecordSignedOut() {
    const recordSignedOut = (user: Pick<UserContextValue, 'email' | 'firstName' | 'lastName'>) => {
        trackEvent("Signed Out", {
            email: user?.email ?? '',
            user_name: `${user?.firstName ?? ''} ${user?.lastName ?? ''}`
        });
    }
    return recordSignedOut
}